import React, { useState, useEffect } from 'react';
import NavigationMenu from '../../presentational/NavigationMenu/NavigationMenu';
import TopMenu from '../../presentational/TopMenu/TopMenu';
import { getSiteTools } from '../../../logic/functions/siteTools.function';
import { getQuickSearchResultsAction } from '../../../store/actions/search.data.actions';
import { getDisplayName } from '../../common/utils';
import { NavigationTree } from '../../../logic/domains/navigationTree.domain';
import { useAdviserDetails } from '../../hooks/AppStateHook';
import { useDispatch } from 'react-redux';

type Props = {
	navigationTree: NavigationTree;
};

const HeaderContainer = (props: Props) => {
	const [siteToolsData, setsiteToolsData] = useState<any>([]);
	const adviser = useAdviserDetails();
	const dispatch = useDispatch();

	useEffect(() => {
		getSiteTools().then(siteTools => {
			setsiteToolsData(siteTools);
		});
		if (adviser.customerToken) {
			dispatch(getQuickSearchResultsAction(adviser.customerToken));
		}
	}, [adviser.customerToken]);

	const adviserInfo = {
		adviserName: getDisplayName(adviser),
		adviserRoles: adviser.roles,
	};

	return (
		<header>
			{siteToolsData ? (
				<TopMenu
					siteToolsData={siteToolsData}
					adviserInformation={adviserInfo}
				/>
			) : null}

			<NavigationMenu
				menuItems={props.navigationTree.menuData}
				licenseeMenu={props.navigationTree.licenseeMenu}
				homeLogoLink={props.navigationTree.homeLink}
			/>
		</header>
	);
};

export default HeaderContainer;
